angular.module('bmsApp.sm')
	.directive('smEmployeeAvailabilityCalendar', [
		'moment',
		'$filter',
		'ConfigService',
		'EmployeeOptionsSvc',
		'SMScheduleSvc',
		function (moment,
				  $filter,
				  ConfigService,
				  EmployeeOptionsSvc,
				  SMScheduleSvc) {

			return {
				restrict: 'E',
				scope: {
					date: '=',
					employees: '=',
					job: '=',
					jobDurationMins: '<',
					jobLicense: '<',
					jobPostcode: '<',
					isModal: '<',
					onEmployeeStartTimeClicked: '&'
				},
				replace: true,
				templateUrl: 'ng/sm/directives/employeeAvailabilityCalendar/EmployeeAvailabilityCalendar.html',
				link: function (scope, element, attrs) {

					function init(scope) {
						self.loading = true;
						self.type.value = 'overview';
						self.jobContext = false;
						// self.params.date = scope.date || new moment();
						var date = scope.date || new moment();
						if (!moment.isMoment(date)) {
							date = moment(date, 'YYYY-MM-DD');
						}
						date.startOf('week');
						self.params.date = date.format('YYYY-MM-DD');
						self.params.employees = scope.employees;
						// hacky watch so that employees get updated
						scope.$watch(function () {
							return scope.employees;
						}, function () {
							self.params.employees = scope.employees;
						});
						if (angular.isObject(scope.job)) {
							self.params.job_id = scope.job.id;
							self.params.job_license_id = scope.job.license.id;
							if (self.params.employees.length === 0 && angular.isObject(scope.job.preferred_employee)) {
								self.params.employees.push(scope.job.preferred_employee.id);
							}
							self.jobContext = true;
						}
						else if (angular.isDefined(scope.jobDurationMins) && angular.isObject(scope.jobLicense) && angular.isDefined(scope.jobPostcode)) {
							self.params.job_duration_mins = scope.jobDurationMins;
							self.params.job_license_id = scope.jobLicense.id;
							self.params.job_postcode = scope.jobPostcode;
							self.jobContext = true;
						}
						scope.config = ConfigService.config;
						scope.datePickerConfig = angular.copy(ConfigService.config.datePicker.basic);
						self.isModal = scope.isModal;
						if (self.isModal) {
							scope.datePickerConfig.options.parentEl = '.modal-content';
						}
						scope.$watch(function () {
							return {
								params: self.params,
								type: self.type
							};
						}, function () {
							self.updating = true;
							fetchData()
								.then(function () {
									self.updating = false;
								});
						}, true);
						EmployeeOptionsSvc.employee()
							.then(function (response) {
								self.options.employee = response.data.options;
								self.loading = false;
							});
						// self.loading = false;
					}

					function prev() {
						var prev = moment(self.params.date, 'YYYY-MM-DD')
							.subtract(1, 'weeks')
							.startOf('week');
						self.params.date = prev.format('YYYY-MM-DD');
					}

					function next() {
						var next = moment(self.params.date, 'YYYY-MM-DD')
							.add(1, 'weeks')
							.startOf('week');
						self.params.date = next.format('YYYY-MM-DD');
					}

					function hourMoment(date, hour, halfHour) {
						halfHour = halfHour || false;
						if (!moment.isMoment(date)) {
							date = new moment(date);
						}
						hour = new moment(date.format('YYYY-MM-DD') + ' ' + hour);
						if (halfHour) {
							hour.add(30, 'm');
						}
						return hour;
					}

					function toggleFilter() {
						self.filter.visible = !self.filter.visible;
					}

					function setView(view) {
						self.type.value = view;
					}

					function fetchData() {
						var params = angular.copy(self.params);
						if (self.type.value === 'overview') {
							return SMScheduleSvc.employeeScheduleOverview(params)
								.then(function (response) {
									self.dates = response.data.date_collection;
									self.employees = response.data.employee_collection;
								});
						}
						else if (self.type.value === 'time_slots' || self.type.value === 'start_times') {
							return SMScheduleSvc.employeeScheduleTimeSlots(params)
								.then(function (response) {
									self.dates = response.data.date_collection;
									self.hours = response.data.hour_collection;
									self.employees = response.data.employee_collection;
									calculateSlotSizes();
									generateEmployeeDateHourStartTimes();
								});
						}
					}

					function calculateSlotSizes() {
						angular.forEach(self.employees, function (employee) {
							angular.forEach(employee.schedule_time_slots, function (timeSlotDay, timeSlotDate) {
								angular.forEach(timeSlotDay, function (timeSlotType) {
									angular.forEach(timeSlotType, function (timeSlot) {
										var timeSlotStart = new moment(timeSlot.start);
										var timeSlotEnd = new moment(timeSlot.end);
										var timeSlotMinutes = timeSlotEnd.diff(timeSlotStart, 'minutes');
										var dayStart = new moment(timeSlotDate + ' ' + _.first(self.hours));
										var dayEnd = new moment(timeSlotDate + ' ' + _.last(self.hours)).add(1, 'hours');
										var dayMinutes = dayEnd.diff(dayStart, 'minutes');
										var timeSlotStartOffset = timeSlotStart.diff(dayStart, 'minutes');
										timeSlot.width = timeSlotMinutes / dayMinutes * 100;
										timeSlot.left = timeSlotStartOffset / dayMinutes * 100;
									});
								});
							});
						});
					}

					function generateEmployeeDateHourStartTimes() {
						if (self.jobContext) {
							angular.forEach(self.employees, function (employee) {
								employee.date_hour_start_times = {};
								angular.forEach(self.dates, function (date) {
									var dateStartTimes = {};
									angular.forEach(self.hours, function (hour) {
										var hourStartTimes = {
											start: {
												date_time: new moment(date + ' ' + hour),
												available: false
											},
											half: {
												date_time: new moment(date + ' ' + hour).add(30, 'm'),
												available: false
											}
										};
										angular.forEach(hourStartTimes, function (hourStartTime) {
											if (angular.isObject(employee.schedule_time_slots[date])) {
												let day = moment(date).format('dddd').toLowerCase();
												let partTimeDaysArray = employee.part_time_days;
												let worksOnDay = (partTimeDaysArray[day] === false) ? false : true;
												hourStartTime.available = worksOnDay && (employee.schedule_time_slots[date].start_times.indexOf(hourStartTime.date_time.format('YYYY-MM-DD HH:mm:ss')) != -1);
												if (!hourStartTime.available) {
													let takenSlots = employee.schedule_time_slots[date].taken;
													let slot = $filter('filter')(takenSlots, function(item) {
														let start = moment(item.start);
														let end = moment(item.end);
														return hourStartTime.date_time.isBetween(start, end, null, '[]');
													});
													if (slot.length) {
														hourStartTime.job = slot[0].job;
													}
												}
											}
										});
										dateStartTimes[hour] = hourStartTimes;
									});
									employee.date_hour_start_times[date] = dateStartTimes;
								});
							});
							console.log(self.employees);
						}
					}

					var self = scope.calendar = {
						loading: false,
						updating: false,
						filter: {
							visible: false
						},
						type: {
							value: undefined
						},
						dates: undefined,
						hours: undefined,
						employees: undefined,
						options: {},
						params: {
							date: undefined
						},
						methods: {
							init: init,
							prev: prev,
							next: next,
							hourMoment: hourMoment,
							toggleFilter: toggleFilter,
							setView: setView
						}
					};

					self.methods.init(scope);

				}
			};
		}
	]);
